import { render } from "./DocumentView.vue?vue&type=template&id=5c88b69c"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=5c88b69c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__